import { Input } from "@mantine/core";
import { useRef } from "react";
import { useFormContext } from "react-hook-form";
import { useInputProps } from "src/generator/hooks/useInputProps";

import { getMatchedFieldId, getMatchedValue } from "./ClickInput.utils";

interface Props {
  id: string;
  value: string;
  required: boolean;
  unit: string;
  width: string;
}

const ClickPopulateInput = ({ id, value, required, unit, width }: Props) => {
  const { ref: addToRefs, ...inputProps } = useInputProps(id, value, required);
  const { setValue } = useFormContext();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const yachtdata = JSON.parse(localStorage.getItem("yachtData") ?? "");
  const yachtValue = yachtdata?.gmdss ? yachtdata.gmdss[unit] : "";

  const handleClick = () => {
    if (yachtValue) inputProps.onChange(yachtValue);
    if (inputRef.current) {
      const matchedFieldId = getMatchedFieldId(inputRef.current, unit, false);
      const matchedValue = getMatchedValue(yachtValue, unit);
      if (matchedFieldId && matchedValue) {
        setValue(matchedFieldId, matchedValue);
      }
    }
  };

  return (
    <Input
      ref={ref => {
        inputRef.current = ref;
        addToRefs(ref);
      }}
      miw={width ? Number(width) * 10 : 150}
      onClick={handleClick}
      {...inputProps}
    />
  );
};

export default ClickPopulateInput;
